import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStories, type StoryApi } from '../../api/client';

export default function StoriesList() {
  const navigate = useNavigate();
  const [stories, setStories] = useState<StoryApi[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getStories()
      .then(setStories)
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load stories'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-green-50 pt-4 pb-12 px-4">
      <div className="max-w-4xl mx-auto">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="text-amber-700 hover:text-amber-800 text-sm mb-6"
        >
          ← Back to home
        </button>
        <h1 className="text-2xl md:text-3xl font-bold text-amber-950 mb-2" style={{ fontFamily: 'Ubuntu, sans-serif' }}>
          African Storytelling
        </h1>
        <p className="text-stone-600 mb-8">Stories from the motherland.</p>

        {loading && <div className="flex gap-4 flex-wrap"><div className="h-40 w-64 rounded-xl bg-amber-100 animate-pulse" /><div className="h-40 w-64 rounded-xl bg-amber-100 animate-pulse" /></div>}
        {error && <p className="text-amber-800">{error}</p>}
        {!loading && !error && stories.length === 0 && <p className="text-stone-500">No stories yet.</p>}
        {!loading && !error && stories.length > 0 && (
          <div className="grid gap-6 sm:grid-cols-2">
            {stories.map((story) => (
              <button
                key={story.id}
                type="button"
                onClick={() => navigate(`/stories/${story.id}`)}
                className="text-left rounded-xl overflow-hidden bg-white border border-amber-100 shadow-sm hover:shadow-md hover:border-amber-200 transition-all focus:outline-none focus:ring-2 focus:ring-amber-400"
              >
                {story.cover_image ? (
                  <div className="aspect-video w-full overflow-hidden bg-amber-100">
                    <img src={story.cover_image} alt="" className="w-full h-full object-cover" />
                  </div>
                ) : (
                  <div className="aspect-video w-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
                    <i className="ri-quill-pen-line text-2xl text-slate-500/50" aria-hidden />
                  </div>
                )}
                <div className="p-4">
                  <h2 className="font-semibold text-amber-950 line-clamp-2">{story.title}</h2>
                  <p className="text-sm text-stone-600 line-clamp-2 mt-1">{story.excerpt || 'No excerpt.'}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
